import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";

const AccountFormModal = ({ isOpen, toggle, isEdit, account, roles, onSubmit }) => {
  // Valeurs initiales selon si on modifie ou crée
  const initialValues = {
    uid: account?.uid || "",
    email: account?.email || "",
    role_id: account?.role_id || "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Veuillez saisir une adresse email valide")
      .required("Veuillez saisir l'email"),
    role_id: Yup.number().required("Veuillez sélectionner le rôle"),
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag="h4">
        {isEdit ? "Modifier l'utilisateur" : "Ajouter un utilisateur"}
      </ModalHeader>

      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, { resetForm }) => {
            onSubmit(values);
            // Reset uniquement si on est en ajout, pas en modification
            if (!isEdit) resetForm();
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs="12">
                  <div className="mb-3">
                    <Label>Email</Label>
                    <Input
                      name="email"
                      placeholder="Email"
                      type="text"
                      autoFocus={!isEdit} // autofocus seulement à la création
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      invalid={touched.email && !!errors.email}
                      disabled={isEdit} // optionnel : bloquer l'email en modification si nécessaire
                    />
                    <FormFeedback>{errors.email}</FormFeedback>
                  </div>

                  <div className="mb-3">
                    <Label>Profil</Label>
                    <Input
                      name="role_id"
                      type="select"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.role_id}
                      invalid={touched.role_id && !!errors.role_id}
                    >
                      <option value="">-- Sélectionner --</option>
                      {roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>{errors.role_id}</FormFeedback>
                  </div>

                   <div className="mb-3">
                    <Label>Mot de passe</Label>
                    <Input
                      name="password"
                      placeholder="Mot de passe"
                      type="password"
                      autoFocus={!isEdit} // autofocus seulement à la création
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      invalid={touched.password && !!errors.password}
                      disabled={isEdit} // optionnel : bloquer l'email en modification si nécessaire
                    />
                    <FormFeedback>{errors.password}</FormFeedback>
                  </div>

                   <div className="mb-3">
                    <Label>Confirmation de mot du passe</Label>
                    <Input
                      name="password_confirmation"
                      placeholder="Confirmation du mot de passe"
                      type="password"
                      autoFocus={!isEdit} // autofocus seulement à la création
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.passwordConfirmation}
                      invalid={touched.passwordConfirmation && !!errors.passwordConfirmation}
                      disabled={isEdit} // optionnel : bloquer l'email en modification si nécessaire
                    />
                    <FormFeedback>{errors.passwordConfirmation}</FormFeedback>
                  </div>
                </Col>
              </Row>

              <div className="text-end">
                <Button color="primary" type="submit">
                  {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default AccountFormModal;
